import { InlineBuildableNode } from "../../InlineBuildableNode";
import { InputBoxView } from "../common/view/InputBoxView";

export class TextBoxNode extends InlineBuildableNode {
    // Variables
    // =======================================

    /** The name of the node */
    public static readonly NODE_NAME = "text-box";

    // Overrides
    // =======================================

    /** [Override] Get the name of the extension */
    public get name(): string {
        return TextBoxNode.NODE_NAME;
    }

    /** [Override] Get the view for the text box */
    public get view(): typeof InputBoxView {
        return InputBoxView;
    }
}
